


























import { Component, Vue } from 'vue-property-decorator';
import ExpandableFAQ from '@/components/global/ExpandableFAQ.vue';

@Component({
    components: {
        ExpandableFAQ,
    },
})
export default class Default extends Vue {
    get papyrusFAQ() {
        return this.$store.getters.getPapyrus;
    }

    get nfcTagFAQ() {
        return this.$store.getters.getNFCTags;
    }
}
